import { Resource } from "../resource/resource.model";

export class CoreContact extends Resource {
    html?: string;
    id: string;
    name: string;
    type: string;
    label: string;
    description: string;
    businessUnit: string;
    preferenceCatalogId: string;
    internalDescription: string;
    customCSS: string;
    status: string;
    tenantId: string;
    createdAt: Date;
    updatedAt: Date;
    translations: { [languageCode: string]: { label?: string; description?: string } };
    isRequired: boolean;
    isEmailIdentifier: boolean;
}
